import appConstants from 'src/constants/appConstants';

const {
  MINIMUM_TABLET_SCREEN_PIXELS,
  MINIMUM_DESKTOP_SCREEN_PIXELS,
} = appConstants;

const DEVICE = {
  MOBILE: `(max-width: ${MINIMUM_TABLET_SCREEN_PIXELS}px), (max-height: ${MINIMUM_TABLET_SCREEN_PIXELS}px)`,
  MOBILE_PORTRAIT: `(max-width: ${MINIMUM_TABLET_SCREEN_PIXELS}px) and (orientation: portrait)`,
  MOBILE_LANDSCAPE: `(max-height: ${MINIMUM_TABLET_SCREEN_PIXELS}px) and (orientation: landscape)`,
  DESKTOP: `(min-width: ${MINIMUM_DESKTOP_SCREEN_PIXELS}px) and (min-height: ${MINIMUM_DESKTOP_SCREEN_PIXELS}px)`,
  DESKTOP_PORTRAIT: `(min-width: ${MINIMUM_TABLET_SCREEN_PIXELS}px) and (orientation: portrait)`,
};

export default {
  DEVICE,
};
